import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import classNames from "classnames";
import TabSelect from "../../elements/tab-select";
import { NavLink } from "react-router-dom";

const TabMenu = ({ tabMenu, onTabClicked = () => {}, selectedTabIndex = 0, selectedOptionIndex = null, match }) => {
  const onSubMenuClick = (event, tab, option) => onTabClicked(event, tab, option);

  const createTabSubMenu = (tab, selectedOption) => {
    if (tab.index !== selectedTabIndex) {
      selectedOption = null;
    }
    return (
      <React.Fragment>
        <TabSelect tab={tab} selected={selectedOption} onSelect={onSubMenuClick} />
      </React.Fragment>
    );
  };

  const createTabBar = (tabs, selectedTabIndex, selectedOption) => {
    return tabs.map((tab, i) => {
      let tabItemClasses = classNames("tab-item", {
        active: selectedTabIndex.toString() === i.toString()
      });

      if (!tab.path) {
        return (
          <span key={i} className={tabItemClasses} id={i}>
            {tab.options && tab.options.length ? (
              createTabSubMenu({ ...tab, index: i }, selectedOption)
            ) : (
              <div className="label" onClick={e => onTabClicked(e, { ...tab, index: i })}>
                {tab.label}
              </div>
            )}
          </span>
        );
      } else {
        const pathArr = [match.params.lang, match?.params?.sitecoreRoute?.replace(/^\//, ""), match.params.tabPrefixPath || "l", tab.path];
        return (
          <span key={i} className={tabItemClasses} id={i}>
            <NavLink
              to={`/${pathArr.join("/")}`}
              onClick={event => {
                event.preventDefault();
              }}
            >
              {tab.options && tab.options.length ? (
                createTabSubMenu({ ...tab, index: i }, selectedOption)
              ) : (
                <div className="label" onClick={e => onTabClicked(e, { ...tab, index: i })}>
                  {tab.label}
                </div>
              )}
            </NavLink>
          </span>
        );
      }
    });
  };

  return (
    <React.Fragment>
      <div className={"tab-menu"}>{createTabBar(tabMenu.items, selectedTabIndex, selectedOptionIndex)}</div>
    </React.Fragment>
  );
};

TabMenu.propTypes = {
  tabMenu: PropTypes.object,
  onTabClicked: PropTypes.func,
  selectedTabIndex: PropTypes.number,
  selectedOptionIndex: PropTypes.number,
  match: PropTypes.object
};

TabMenu.defaultProps = {
  onTabClicked: () => {},
  selectedTabIndex: 0,
  selectedOptionIndex: null
};

export default TabMenu;
